module.exports = __webpack_public_path__ + "img/技术优势2.fc19f5f1.png";